<script setup lang="ts">
import type { ComponentBrandProductCategoryProps } from "./ComponentBrandProductCategory.props"

const props = defineProps<ComponentBrandProductCategoryProps>()
//Since we are in the brand page the category links needs to be filtered by the brand selected
props.cards.map((el) => {
  let pathComponents = el.path.split("?")
  let basePath = pathComponents[0]
  let pathParams = new Set(
    pathComponents.length > 1 ? pathComponents[1].split("&") : []
  )
  if (el.path && !!props.brandName && el.addContextParameters) {
    pathParams.add(`refinementList%5Bbrand.name%5D%5B0%5D=${props.brandName}`)
  }
  el.path =
    basePath + (pathParams.size > 0 ? "?" + [...pathParams].join("&") : "")
})
</script>

<template>
  <div class="cms-products-category negative-margined mb-6">
    <ProductBlocksBrandsProductsCategory v-if="props" v-bind="props" />
  </div>
</template>
